export default {
    methods: {
        addStudent() {
            if (this.student_data.id_document_type === '' || this.student_data.document === '') {
              this.$vs.dialog({
                type: 'alert',
                color: 'danger',
                title: 'Error',
                text: `Por favor, ingrese el ${!this.student_data.id_document_type ? 'tipo de documento' : 'numero de documento'}`,
                acceptText: 'Aceptar'
              })
              return
            }
            if (this.studentsData.length > 0) {

              // Document match checker before service call
              const student = this.studentsData.find(student => student.document === this.student_data.document)
              if (student) {
                this.$vs.dialog({
                  type: 'alert',
                  color: 'danger',
                  title: 'Error',
                  text: 'El estudiante ya está en la lista',
                  acceptText: 'Aceptar'
                })
                return
              }
            }
            this.$vs.loading()
            this.$store.dispatch('userManagement/getStudent', this.student_data).then(response => {
              this.$vs.loading.close()
              const student = response.data.account.length > 0 ? response.data.account[0] : null
              if (student) {

                // Document match checker after service call
                const validStudent = this.studentsData.find(pupil => pupil.id_pupil === student.id_pupil) === undefined

                console.log('student', student)
                console.log('validStudent', validStudent)
                console.log('stuentsData', this.studentsData)

                if (validStudent) {
                  this.student_data = { id_document_type: '', document: '' }
                  student.full_name = `${student.name} ${student.last_name}`
                  this.studentsData.unshift(student)
                  this.showNotify(false, 'Estudiante agregado', 'Se agregó el estudiante a la lista')
                } else {
                    this.$vs.dialog({
                      type: 'alert',
                      color: 'danger',
                      title: 'Error',
                      text: 'El estudiante ya está en la lista',
                      acceptText: 'Aceptar'
                    })
                }
              } else {
                this.$vs.dialog({
                  type: 'alert',
                  color: 'danger',
                  title: 'Error',
                  text: 'El estudiante no fue encontrado',
                  acceptText: 'Aceptar'
                })
              }
            }).catch(error => console.error(error))
        },
        removeStudent(student_document) {
            this.studentsData = this.studentsData.filter(student => student.document !== student_document)
            this.showNotify(false, 'Estudiante eliminado', 'Se eliminó el estudiante de la lista')
        },
        getFormData(data, studentsData) {
            return {
                id_account: data.id_account,
                name: data.name,
                last_name: data.last_name,
                birthday_date: data.birthday_date,
                phone_number: data.phone_number,
                avatar: data.avatar,
                card_id: data.card_id,
                card_type_id: data.card_type_id,
                id_pupils: studentsData.map(student => student.id_pupil),
                address: data.address,
                city: data.city,
                zip_code: data.zip_code
            }
        },
        redirectToUsers() {
          if (this.$route.fullPath !== '/users?tab=1')  this.$router.push('/users?tab=1')
        },
    }
}
